module.exports = __webpack_public_path__ + "static/behave-teaser-bc1cb04e7535ede479bdcd685a2312ad.jpg";